import * as _4 from 'lodash4';
import { CourseGroupBase } from './../../../builders/ap_generic_slot_builder';
import { RouterHelper } from './../../../helpers/router_helper';
export class CourseGroupCourseDetailOpenFacade {
  constructor(private routerHelper: RouterHelper) {}

  isCoursePlanned(courseGroup: CourseGroupBase) {
    return !_4.isEmpty(courseGroup.plannedCourse);
  }

  showCourseDetailsForCourseGroup(courseGroup: CourseGroupBase) {
    if (!courseGroup.plannedCourse) {
      return;
    }
    const courseNk = courseGroup.plannedCourse._course.nk;
    const programSlotId = courseGroup.programSlot.id;
    const slotType = courseGroup.programSlot.slot_type;
    const termId = courseGroup.termId;
    const title = courseGroup.plannedCourse._course._title;

    const courseDetails = {
      courseNk,
      programSlotId,
      slotType,
      termId,
      title
    };
    return this.routerHelper.findStateAndGo('.course_details', { courseDetails });
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngCourseGroupCourseDetailOpenFacade', CourseGroupCourseDetailOpenFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/facades/course_group_course_detail_open_facade.ts